import { useAuth } from '@/services/auth';
import { useFlag } from '@/services/featureFlags';
import { PlanGroup } from '@d-id/types';

const allowedPlanGroups = [
    PlanGroup.PRO,
    PlanGroup.ADVANCED,
    PlanGroup.ENTERPRISE,
    PlanGroup.ENTERPRISE_TRIAL,
    PlanGroup.CREATOR,
    PlanGroup.BUSINESS,
];
export const useIsSubtitlesEnabled = () => {
    const featureFlagEnabled = useFlag('subtitles_enabled', false);
    const { user } = useAuth();

    const isPlanGroupAllowed = user?.planGroup && allowedPlanGroups.includes(user.planGroup);

    return featureFlagEnabled || isPlanGroupAllowed;
};
